import React from 'react'
import './index.css';

export default function ButtonPinkIcon({text, img, handleClick}) {
    return (
        <div onClick={handleClick} className="lovr-btn-pink-icon">
            <div className="lovr-btn-pink-icon-img">
                <img src={require(`../../../assets/icons/${img}`)}/>
            </div>

            <div className="lovr-btn-pink-icon-text">
                <p>{text}</p>
            </div>
        </div>
    )
}
